import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const tabFontSize = {
  '@media (max-height: 768px)': {
    fontSize: rem(0.75),
  },
  '@media (max-height: 576px)': {
    fontSize: rem(0.625),
  },
};

interface PassedProps {
  leftHanded?: boolean;
}

export const styles = makeStyles(theme => ({
  // Tab group only
  tabTextDiv: {
    backgroundColor: themeColor.grayDivider,
    height: '120%',
    position: 'relative',
    bottom: '.3vh',
  },
  tabs: (props: PassedProps) => {
    const leftHandedStyles = { paddingRight: '0.65vw' };
    const rightHandedStyles = { paddingLeft: '0.65vw' };
    return props.leftHanded ? leftHandedStyles : rightHandedStyles;
  },
  tabsIndicator: {
    display: 'none',
  },
  tenderGroupContainer: {
    maxHeight: '80%',
    overflow: 'hidden',
    ...tabFontSize,
  },
  // Tab group only
  tenderGroupTab: {
    width: '100%',
    maxWidth: '100%',
    height: '7.3vh',
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: vh(2.08),
    opacity: 1,
    backgroundColor: themeColor.lightBackground,
    marginBottom: 20,
    borderWidth: 1,
    borderRadius: 2,
    border: `1px solid ${themeColor.lightgrey}`,
    boxSizing: 'border-box',
    boxShadow: `0px 1px 2px ${themeColor.verylightgray}`,
  },
  // Tab group only
  tenderGroupTabSelected: {
    width: '100%',
    maxWidth: '100%',
    height: '7.3vh',
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: vh(2.08),
    marginBottom: 20,
    borderWidth: 1,
    borderRadius: 2,
    border: `0.5vw solid ${theme.palette.secondary.main}`,
    boxShadow: `0px 1px 2px ${themeColor.verylightgray}`,
  },
  // Tab group only
  tenderGroupTabText: {
    lineHeight: 1.63,
    fontWeight: 500,
    fontSize: rem(1),
    letterSpacing: '0.5px',
    fontStyle: 'normal',
    color: themeColor.defaultTextColor,
  },
  // Tab group only
  tenderGroupTabNameText: {
    lineHeight: 1.63,
    color: themeColor.defaultTextColor,
    textAlign: 'left',
    paddingLeft: '1.5vw',
    fontWeight: 500,
    letterSpacing: '0.5px',
    fontStyle: 'normal',
    fontSize: rem(0.875),
  },
  // Tab group only
  tenderGroupTabNameTextSelected: {
    fontSize: rem(1),
    paddingLeft: '2vw',
  },
}));
